import { render, staticRenderFns } from "./ChangeMail.vue?vue&type=template&id=59a804bc&scoped=true"
import script from "./ChangeMail.vue?vue&type=script&lang=js"
export * from "./ChangeMail.vue?vue&type=script&lang=js"
import style0 from "./ChangeMail.vue?vue&type=style&index=0&id=59a804bc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a804bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59a804bc')) {
      api.createRecord('59a804bc', component.options)
    } else {
      api.reload('59a804bc', component.options)
    }
    module.hot.accept("./ChangeMail.vue?vue&type=template&id=59a804bc&scoped=true", function () {
      api.rerender('59a804bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/ChangeMail.vue"
export default component.exports